import React from "react"
// react component for creating dynamic tables
import ReactTable, {ReactTableDefaults} from "react-table"
import {connect} from 'react-redux'
import moment from "moment-timezone";
import { CSVLink } from "react-csv"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
//import TextField from "@material-ui/core/TextField";
// @material-ui/icons
import CreditCard from "@material-ui/icons/CreditCard"
// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import LinearProgress from '@material-ui/core/LinearProgress';

import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Datetime from "react-datetime";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"

import {
  ibRebateEarningsFetch,
  ibRebateEarningsCsv
} from 'actions/ibReports'
import {
  profileFilter,
  profilesAvailableFetch
} from 'actions/profiles'
import {
  ibTreeAvalableFetch
} from 'actions/ibTrees'
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import Button from "components/CustomButtons/Button.jsx";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  datepickerLabel: {
    top: '-20px',
    left: '0',
    position: 'absolute',
    color: 'rgba(0, 0, 0, 0.26) !important',
    padding: '0',
    fontSize: '14px',
    fontWeight: '400',
    //textTransform: 'uppercase',
    lineHeight: '1'
  },
  datepickerText: {
    fontSize: '14px !important',
    paddingTop: '10px !important',
  },
  tableCell: {
    width: '120px',
  },
  cellRight: {
    textAlign: 'right'
  },
  line: {
    borderTop: '2px solid transparent',
    width: '90%',
    position: 'absolute',
    bottom: '-15px'
  },
  highlight: {
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '10px',
    margin: '10px 0',
  }
};

class List extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
			from: 0,
			to: 0,
      includeChildren: true,
      showIncludeChildren: true,
      profileId: 0,
      csv: ''
		}
  }
  csvLink = React.createRef()
	handleChange(e, filter){
    let state = this.state
    let value = filter === 'from' || filter === 'to' ? e : e.target.value
    if(filter === 'includeChildren'){
      value = !this.state.includeChildren
    }

    let includeChildren = this.state.includeChildren
    let showIncludeChildren = this.state.showIncludeChildren

    // showIncludeChildren
    this.props.ibTreeAvalableFetch({profileId: filter === 'profileId' ? value : state.profileId})
      .then((tree) => {
      if(tree.length <= 1) {

        includeChildren = false
        showIncludeChildren = false

      } else {

        includeChildren = true
        showIncludeChildren = true

      }
      state[filter] = value
      this.setState({...state});

      if (filter === 'profileId') {

        this.setState({
          ...state,
            includeChildren: includeChildren,
            showIncludeChildren: showIncludeChildren,
        },() => this.fetchReport());
      
      }
    })
  }
  fetchReport(){
    const{from, to, includeChildren, profileId} = this.state

    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();

    const params = {
      from: Date.parse(fromFormat),
      to: Date.parse(toFormat),
      includeChildren
    }

    if(profileId !== 0)
      params.profileId = profileId

    this.props.fetch(params)
  }
	componentDidMount(){
		this.props.profileFilter({size: 10000})
		this.props.profilesFetch().then((e) => {
      let fromDate = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(2,'day').format()
      let toDate = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format()
      
      let profile = e.content && e.content.length !== 0 ? e.content[0].profileId : 0
      let includeChildren = true
      let showIncludeChildren = true
      //if no sub ibs set includeChildren false
      if(profile !== 0){
        
        this.props.ibTreeAvalableFetch({profileId: profile}).then((tree) => {

          if(tree.length === 1) {
            includeChildren = false
            showIncludeChildren = false
          }
          this.setState({
            profileId: profile,
            includeChildren: includeChildren,
            showIncludeChildren: showIncludeChildren,
            from: fromDate,
            to: toDate
          },() => this.fetchReport())
        })

      }
      
    })
  }

  ValidDate( current ){
      let minDate = moment('2019-07-22 00:00:00');
      
      return current >= minDate;
  }

  exportCsv(){
    const {from, to, includeChildren, profileId} = this.state
    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();
    
    const params = {
      from: Date.parse(fromFormat),
      to: Date.parse(toFormat),
      includeChildren
    }
    if(profileId !== 0)
      params.profileId = profileId
    this.props.ibRebateEarningsCsv(params).then((e) => {
      this.setState({csv: e},() => this.csvLink.current.link.click())
    })
  }
	renderFilters(){
    const {classes, profiles} = this.props
    const {profileId} = this.state
    const fromDate = this.state.from
      ? moment(this.state.from).startOf('day').format('YYYY-MM-DD')
      : ''

    const toDate = this.state.to
      ? moment(this.state.to).endOf('day').format('YYYY-MM-DD')
      : ''
    
		return (
			<GridContainer style={{marginBottom: '30px'}}>
        <GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="profileId" className={classes.selectLabel} >
              Profile
            </InputLabel>
            <Select
              value={profileId}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "profileId"),
                id: "profileId",
                name: "profileId"
              }}>
              {profiles
                .map((e) => (
                  <MenuItem
                    key={e.profileId}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e.profileId}>
                    {e.profileId}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          
        </GridItem>
			
        <GridItem xs={3}>
            
            <FormControl className={classes.selectFormControl} style={{paddingTop: '5px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel}>Start Date *</InputLabel>
              <Datetime
                timeFormat={false}
                dateFormat={'YYYY-MM-DD'}
                inputProps={{placeholder: 'yyyy/mm/dd'}}
                utc={true}
                isValidDate={ this.ValidDate }
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                //isValidDate={valid}
                onChange={(event) => this.handleChange(event, "from")}
                value={fromDate}
                className={classes.select + ' ' + classes.datepickerText}
              />
            </FormControl>
        </GridItem>

        <GridItem xs={3}>
          <FormControl className={classes.selectFormControl} style={{paddingTop: '5px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel}>To Date *</InputLabel>
              <Datetime
                timeFormat={false}
                utc={true}
                //isValidDate={valid}
                dateFormat={'YYYY-MM-DD'}
                isValidDate={ this.ValidDate }
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                inputProps={{placeholder: 'yyyy/mm/dd'}}
                onChange={(event) => this.handleChange(event, "to")}
                value={toDate}
                className={classes.select + ' ' + classes.datepickerText}
              />
          </FormControl>
        </GridItem>
        {this.state.showIncludeChildren && (
          <GridItem xs={3}>
            <FormControlLabel
              style={{marginTop:'15px'}}
              control={
                <Checkbox
                  color="default"
                  checked={this.state.includeChildren}
                  onChange={(event) => this.handleChange(event, "includeChildren")}
                />
              }
              classes={{
                label: classes.linkFooter
              }}
              label="Including SubIBs"
            />
          </GridItem>
        )}
        <GridItem xs={1}>
          <div style={{float:'right'}}>
            <Button onClick={() => this.fetchReport()} className={classes.submit} color="success">Search</Button>
          </div>
        </GridItem>
			</GridContainer>
		)
  }
  setPageSizeOptions(data){
    const pageSizeOptions = [10]
    if(data.length > 10) {
      pageSizeOptions.push(20)
    }
    if(data.length > 20) {
      pageSizeOptions.push(50)
    }
    if(data.length > 50) {
      pageSizeOptions.push(100)
    }

    Object.assign(ReactTableDefaults, {
      pageSizeOptions: pageSizeOptions,
    })
    return pageSizeOptions
  }
  render() {
    const {classes, report:{data, additionalData},reports} = this.props
    this.setPageSizeOptions(data)

    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <CreditCard />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>My Reports</h4>
            </CardHeader>
            <CardBody>
							{this.renderFilters()}
              
            {(reports.isFetching) ?
            (<LinearProgress color="primary"/>)
            :
							(<div>
              {/*<div style={{width: '100%', textAlign: 'right', padding: '10px'}}>
                {additionalData.opening_balance && <span className={classes.highlight}>Opening balance (USD):&nbsp;
                <span>{(Math.round(additionalData.opening_balance * 100) / 100).toFixed(2).toLocaleString()}</span></span>}
              </div>*/}
              <ReactTable
                data={data}
                columns={[
                  {
                    id: '-1',
                    sortable: true,
                    Header: () => <div><span>{'Date'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[25],
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '1',
                    sortable: true,
                    Header: () => <div><span>{'Time'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[0],
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '2',
                    Header: () => <div><span>{'Ticket'}</span></div>,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    width: 100,
                    headerClassName: 'customHeader',
                    accessor: d => d[2],
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '3',
                    Header: () => <div className={classes.tableCell}><span>{'Trading Account Number'}</span></div>,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    width: 120,
                    headerClassName: 'customHeader',
                    accessor: d => d[4],
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '4',
                    Header: () => <div className={classes.tableCell}><span style={{width: '80px'}}>{'Platform'}</span></div>,
                    width: 120,
                    headerClassName: 'customHeader',
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    accessor: d => d[6],
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '5',
                    Header: () => <div className={classes.tableCell}><span>{'Currency'}</span></div>,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    width: 120,
                    headerClassName: 'customHeader',
                    accessor: d => <span>{d[24]}</span>,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '6',
                    Header: () => <div className={classes.tableCell}><span>{'Client Name'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[10],
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '7',
                    Header: () => <div className={classes.tableCell}><span>{'Attached IB Name'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[12],
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '8',
                    Header: () => <div className={classes.tableCell}><span>{'Profile Name'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[14],
                    Footer: (
                      <span className={classes.highlight}>Total (USD)</span>
                    )
                  },
                  {
                    id: '9',
                    Header: () => <div className={classes.tableCell}><span>{'Volume (USD)'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[15] * 100) / 100).toLocaleString(),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_volume) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '10',
                    Header: () => <div className={classes.tableCell}><span>{'Amount'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[22] * 100) / 100).toLocaleString(),
                    Footer: (
                      ''
                    )
                  },
                  {
                    id: '11',
                    Header: () => <div className={classes.tableCell}><span>{'Commission (USD)'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[19] * 100) / 100).toLocaleString(),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_commission) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '12',
                    Header: () => <div className={classes.tableCell}><span>{'Commission Rebates (USD)'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[16] * 100) / 100).toLocaleString(),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_trade_server_commission) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '13',
                    Header: () => <div className={classes.tableCell}><span>{'Markup Rebates (USD)'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[17] * 100) / 100),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_markup) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '14',
                    Header: () => <div className={classes.tableCell}><span>{'Spread Rebates (USD)'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[18] * 100) / 100),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_spread) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '15',
                    Header: () => <div className={classes.tableCell}><span>{'Rebate on Shares (USD)'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[20] * 100) / 100),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_percentage) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '16',
                    Header: () => <div className={classes.tableCell}><span>{'Total Rebates (USD)'}</span></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[21] * 100) / 100),
                    Footer: (
                      additionalData ? <span>{(Math.round(Number(additionalData.total_total) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight thead-border"
              />
              
              <div style={{float:'left', marginTop: '20px', display: 'inline-block'}}>
                <span>* Trading day starts at 5pm New York timezone.</span>
              </div>
              <div style={{width: '100%', textAlign: 'right', marginTop: '20px'}}>
                {additionalData.total_total && 
                  <span className={classes.highlight}>Rebates (USD):&nbsp;
                      <span>{additionalData.total_total.toLocaleString()}</span>
                  </span>
                }
              </div>
              
              {/*<div style={{width: '100%', textAlign: 'right', marginTop: '20px'}}>
                {additionalData.withdrawals && 
                  <span className={classes.highlight}>Withdrawals (USD):&nbsp;
                      <span>{additionalData.withdrawals.toLocaleString()}</span>
                  </span>
                }
              </div>
              
              <div style={{width: '100%', textAlign: 'right', marginTop: '20px'}}>
                {additionalData.closing_balance && 
                  <span className={classes.highlight}>Closing Balance (USD):&nbsp;
                      <span>{(Math.round(additionalData.closing_balance * 100) / 100).toFixed(2).toLocaleString()}</span>
                  </span>
                }
              </div>*/}

              </div>
              )}
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>
          <div style={{float:'right'}}>
            <Button onClick={() => this.exportCsv()} className={classes.submit} color="success">Export CSV</Button>
            <CSVLink data={this.state.csv} filename={"rebate-earnings.csv"} ref={this.csvLink} className="hidden" />
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  report: state.ibReports.ibRebateEarnings,
	reports: state.ibReports,
	profiles: state.profiles.list
})

const mapDispatchToProps = (dispatch) => ({
  fetch: (params) => dispatch(ibRebateEarningsFetch(params)),
  ibRebateEarningsCsv: (params) => dispatch(ibRebateEarningsCsv(params)),
	profilesFetch: () => dispatch(profilesAvailableFetch()),
  profileFilter: (filter) => dispatch(profileFilter(filter)),
  ibTreeAvalableFetch: (data) => dispatch(ibTreeAvalableFetch(data))
})

export default withStyles({...styles, ...selectStyles, ...extendedFormsStyle})(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/RebateEarningsReport/List.jsx